import './Checkboxes.scss';
import { NOT_AVAILABLE_VALUE } from '../../utils/constants';
import { Option } from '../../models/generic';

interface Props {
  checkboxId: string;
  options: Option[];
  value?: any[];
  onChange: (value: any) => void;
}

const Checkboxes = ({ checkboxId, options, value = [], onChange }: Props) => {
  const onToggle = (selectedValue: string, checked: boolean) => {
    let newValues = [...value];

    if (checked) {
      if (!newValues.includes(selectedValue)) {
        newValues.push(selectedValue);
      }

      if (selectedValue !== NOT_AVAILABLE_VALUE) {
        newValues = newValues.filter((v) => v !== NOT_AVAILABLE_VALUE);
      }
    } else {
      newValues = newValues.filter((v) => v !== selectedValue);
    }

    if (checked && selectedValue === NOT_AVAILABLE_VALUE) {
      newValues = [NOT_AVAILABLE_VALUE];
    }

    onChange(newValues);
  };

  return (
    <div id={checkboxId} className="checkbox-section">
      {options.map((o, index) => {
        const itemId = `${checkboxId}-input-${index}`;
        const checked = value.includes(o.value);
        return (
          <div key={itemId} className="chk-box">
            <label className="chk-label">
              <input
                type="checkbox"
                checked={checked}
                onChange={(e) => onToggle(o.value, e.target.checked)}
              />
              {o.label}
            </label>
          </div>
        );
      })}
    </div>
  );
};

export default Checkboxes;
